export const removeDuplicates = (arr) => {
    return [...new Set(arr)];
}